import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InvoiceWriteoffReducer } from '../reducers';

export const selectInvoiceWriteoffFeature = createFeatureSelector<InvoiceWriteoffReducer.InvoiceWriteoffState>(InvoiceWriteoffReducer.featureName);

export const selectInvoiceWriteoff = createSelector(selectInvoiceWriteoffFeature, (state: InvoiceWriteoffReducer.InvoiceWriteoffState) => state.item);
